import { render, staticRenderFns } from "./FjPageLoader.vue?vue&type=template&id=0b6c061a&scoped=true&"
var script = {}
import style0 from "./FjPageLoader.vue?vue&type=style&index=0&id=0b6c061a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6c061a",
  null
  
)

export default component.exports